import Shadowable from "../../mixins/Shadowable";
import Loadable from "../../mixins/Loadable";
import GridElement from "../Layout/Grid/GridElement";

export default {

    mixins: [GridElement, Shadowable, Loadable],

    props: {

        // A boolean to state whether a medium border radius shall be shown or a specific radius size string
        rounded: {
            type: [String, Boolean],
            default: true
        },

        // A boolean to state whether a medium shadow shall be shown or a specific shadow size string
        shadow: {
            type: [String, Boolean],
            default: true
        },

        // Whether the card shall retrieve a border
        outlined: {
            type: Boolean,
            default: false
        },

        height: {
            type: [String, Number],
            default: null
        }
    },

    computed: {
        // The props to bind to the 'Card' component when using it as a child component
        cardProps() {
            // Do not add 'height' since it is often manipulated within a component
            return {
                shadow: this.shadow,
                loading: this.isLoading,
                outlined: this.outlined,
                flat: this.flat,
                xsTile: this.xsTile,
                smTile: this.smTile,
                mdTile: this.mdTile,
                lgTile: this.lgTile,
                noSpacing: this.noSpacing,
                rounded: this.rounded,
                tile: this.tile,
                roundedSmall: this.roundedSmall,
                roundedLarge: this.roundedLarge
            }
        }
    }

}